<template>
    <address-sub-element-layout
        v-bind="subElementLayoutModel"
        v-on:update="sendDataChange"
        v-on:same-as-selected="sameAsSelected"
        v-on:validated="onAddressValidated"
        v-on:update-has-location-validation-errors="updateHasLocationValidationErrors"
        v-on:help-clicked="$emit('help-clicked')">
        <template v-slot:help>
            <slot name="help" />
        </template>
    </address-sub-element-layout>
</template>

<script>
    import addressSubElement from "./addressSubElement.js";
    import { AUX_MUTATION } from "Forms/Components/ProjectForm/projectFormStore";

    export default {
        extends: addressSubElement,
        emits: ["help-clicked"],
        data() {
            return {
                hasLocationValidationErrors: false
            };
        },
        methods: {
            updateHasLocationValidationErrors(value) {
                this.hasLocationValidationErrors = value;
                this.$store.commit(AUX_MUTATION, {
                    elementId: this.element.PublicId,
                    auxState: { hasLocationValidationErrors: value }
                });
            }
        }
    };
</script>
